<div class="modal-header">
  <h4 class="modal-title">Notifications</h4>
  <button type="button" class="btn-close btn-close-white" aria-label="Close" (click)="close()"></button>
</div>
<div class="modal-body">
  @if (notifications.length > 0){
    <h4>{{notifications[idx].title}}</h4>
    <div [innerHTML]="notifications[idx].message"></div> 
    <div class="text-end">
      <button type="button" class="btn btn-secondary btn-sm" (click)="prev()"><i class="fa-solid fa-chevron-left"></i></button>
      {{idx+1}} of {{notifications.length}}
      <button type="button" class="btn btn-secondary btn-sm" (click)="next()"><i class="fa-solid fa-chevron-right"></i></button>
    </div>
  }
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-secondary" (click)="dismissAllNotifications()">Dismiss All</button>
  <button type="button" class="btn btn-secondary" (click)="dismissNotification()">Dismiss</button>
  <!--<button type="button" class="btn btn-primary" (click)="yes()">Yes</button>-->
</div>
